const formatDate = (dateString) => {
  //jan 1 2000 used as a dummy date if need
  if (dateString == null || dateString == '2000-01-01') {
    return ''
  }

  var dateData = dateString.split('-')
  let day = dateData[2]
  if (day == '' || day == null) {
    day = '1'
  }
  let date = new Date(dateData[0],dateData[1]-1,day)
  return date.localeDateShortenYear()
}

export {formatDate}
